import { backendFetchCached } from './BackendApi.ts';
import { InsuranceCompanyData } from '@/common/types';

export async function loadInsuranceCompanies(): Promise<
  InsuranceCompanyData[]
> {
  return backendFetchCached<InsuranceCompanyData[]>(
    '/insurance_companies',
    {
      key: 'insurance_companies_cache_v1',
      ttlMinutes: 24 * 60, // 24 hours
    },
    {
      credentials: 'include',
    }
  );
}
